module.exports = __webpack_public_path__ + "img/20190701160526QQ截图20190701150248.58ff4f1b.png";